import { NOTIFICATION_CHANNEL, NOTIFICATION_CHANNEL_OBJ } from "../constants/scheduler.constants";
import { z } from "zod";

export const notificationWebhookSchema = z.object({
  url: z.string().default(""),
});

export const notificationTelegramSchema = z.object({
  botToken: z.string().default(""),
  chatId: z.string().default(""),
});

export const notificationEmailSchema = z.object({
  host: z.string().default(""),
  port: z.number().int().min(1).max(65535).default(465),
  user: z.string().default(""),
  password: z.string().default(""),
  from: z.string().default(""),
  to: z.string().default(""),
  secure: z.boolean().default(true),
});

export const notificationConfigSchema = z.object({
  channel: z.enum(NOTIFICATION_CHANNEL).default(NOTIFICATION_CHANNEL_OBJ.NONE),
  webhook: notificationWebhookSchema.default({ url: "" }),
  telegram: notificationTelegramSchema.default({ botToken: "", chatId: "" }),
  email: notificationEmailSchema.default({
    host: "",
    port: 465,
    user: "",
    password: "",
    from: "",
    to: "",
    secure: true,
  }),
});

export type NotificationConfig = z.infer<typeof notificationConfigSchema>;

export const DEFAULT_NOTIFICATION_CONFIG: NotificationConfig =
  notificationConfigSchema.parse({});
